import { AppProvider } from '@/providers/app';
import { AppRoutes } from '@/routes';
import '@/styles/tailwind.css';

function App() {
  return (
    <AppProvider>
      <AppRoutes />
    </AppProvider>
  );
}

export default App;
